import React from "react";

export default class Terms extends React.Component {
    render() {
        return(
            <div>Terms</div>
        )
    };
}